var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialFacebook = function SvgSocialFacebook(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.067C23 5.95422 18.0758 1 12 1C5.92422 1 1 5.95422 1 12.067C1 17.5919 5.02187 22.17 10.2812 23V15.2661H7.48828V12.067H10.2812V9.62881C10.2812 6.85557 11.9227 5.32305 14.4363 5.32305C15.6395 5.32305 16.8984 5.5392 16.8984 5.5392V8.26272H15.5105C14.1441 8.26272 13.7188 9.11653 13.7188 9.99194V12.067H16.7695L16.2818 15.2661H13.7188V23C18.9781 22.17 23 17.5919 23 12.067Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialFacebook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-facebook.50eafb191bef7797b8ff6f3ef231f8cb.svg";